<template>
  <div style="max-width:900px; margin: auto;">
      <br />
      <h2>Settings</h2>
   <hr />
   <br />
   <div v-if="!$store.state.inApp" class="seasoncast-card">
        <h4 >Channel Type</h4>
        <hr />
  <div style="text-align:center;" class="card-body">
      <h5>Your current account type:</h5>
      <div v-if="channel.premium.active">
          <p class="lead">Premium<br /> 
         <small>Expires: {{ new Date(channel.premium.expire).toISOString().split('T')[0]}}</small></p>

         <form v-if="channel.premium.type == 'renew'" method="POST" action="https://app.seasoncast.com/v2/broadcaster/stripe/portal">
      <input type="hidden" id="custId" name="sub_id" v-bind:value="channel.premium.stripe_sub_id">
     <p class="text-center"> <button class="btn btn-dark " type="submit">Manage Subscription</button></p>
  </form>
       
      </div>
      <div v-else>
          <p class="lead">Free</p>
         
    <p>Unlock all the features of SeasonCast with SeasonCast Premium</p>
    <button class="btn btn-primary" @click="submitBTN">Upgrade Account</button><br /><a class="btn btn-link" href="https://seasoncast.com/Pricing">Learn More</a>

    <div v-if="channel.email.includes('+')">
        <br />
        <p class="text-center">You are using a secondary account. You may be eligible for a bulk discount if you have multiple accounts. <a href="mailto:support@seasoncast.com">Contact us</a> for more information. We are working to automate this process.</p>
      </div>

      </div>
  
   </div>
    </div><br />
<!--  Create Seasoncast-card that displays a table of users and the team role and remove font awesome icon to remove user function from team-->
    <div class="seasoncast-card">
        <h4 >Channel Administrators</h4>
        <hr />
      <!-- add an input email and a click button "Add to Team" that calls function addUser to team -->
      <p>Add an user email to allow them to edit the channel:</p>
      <input type="email" class="form-control" placeholder="Email" v-model="add_email"><br />
      <button class="btn btn-primary"  @click="addUserToTeam">Add to Channel Access</button>
      <hr/>
      <p>Once invited, the invited person with viewer account email and password on the broadcaster login page. If they do not have a viewer account, the user needs to create a viewer account.</p>
        <div class="card-body">
            <table class="table">
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Actions</th>
                    </tr>

                </thead>
                <tbody>
                    <!-- output a row that is the email is channel.email and role as owner  -->
                    <tr>
                        <td>{{channel.email}}</td>
                        <td>owner</td>
                        <td></td>
                    </tr>
                    
                    <tr v-for="member in teamMembers" v-bind:key="member.email">
                        <td>{{ member.email }} <i v-if="member.userId" class="fas fa-check"></i></td>
                        <td>{{ member.role }}</td>

                        <td><button class="btn btn-danger" @click="removeUserFromTeam(member.email)">Remove</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <small>  Note: SeasonCast iOS Legacy App does not currently support with user roles. We have added support on SeasonCast Android App & SeasonCast iOS v6+. This means an viewer with access can login using their account and broadcast.</small>



    </div>
    <br />
    <div class="seasoncast-card">
        <h4 >Channel Admin Tools</h4>
        <hr />
        
        <button class="btn btn-secondary btn-block" @click="renameChannel">Change Channel Username</button>
        <button class="btn btn-secondary btn-block" @click="changeEmail" v-if="!channel.email.includes('+')">Change Channel Email</button>

        <button class="btn btn-danger btn-block" @click="deleteChannel">Delete Channel</button>

        </div>
<br />
    <div class="seasoncast-card">
        <h4 >Feedback</h4>
        <hr />
Love SeasonCast? We have worked hard to make a high-quality product that is also affordable for any level of sports team. That has always been our #1 goal. The best way to support us is by providing us suggestions on how to improve our services, leaving a positive review on the App Store, and telling your friends about us! Thank you for being apart of the SeasonCast community.</div><br />
</div>

</template>
<script>
let API = "https://app.seasoncast.com/"
 import Swal from "sweetalert2"
 import axios from 'axios';
 import cookie from "cookie.js"

export default {
  name: 'Settings',
  props: ['channel'],
  components: {
 
  },
  data () {
    this.publishableKey = "pk_live_FIoO3Hm9m8ya2XvhlMtcv6lt" //"pk_live_FIoO3Hm9m8ya2XvhlMtcv6lt";
    return {
      loading: false,
      add_email: "",
      lineItems: [
        {
          price: 'gt_year', // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      successURL: 'https://seasoncast.com/broadcaster/settings?payment_result=success',
      cancelURL: 'https://seasoncast.com/broadcaster/settings?payment_result=cancel',
      teamMembers: []
    };
  },
  mounted (){
      if (this.$route.query.payment_result == "success"){
          this.did_purchase()
      }
      if (this.$route.query.trialRequest){
         Swal.fire({
          title: 'Do you want to request a 12-day free trial of SeasonCast Premium?',
          text: "We will review your request and get back to you within 24 hours.",
         
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, request a trial!'
        }).then((result) => {
          if (result.value) {
            this.trialRequest()
          }
        })
        }

  },
  created: function () {
    this.getTeamMembers();
  },
  methods:{
    validateEmail: function(email){
     // eslint-disable-next-line no-useless-escape 
      return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    },  
    // removeUserFromTeam : remove a user from the team given an email, call the api endpoint v2/broadcaster/removeUserAccess, then show a message to the user
    removeUserFromTeam: async function(email){
      
      let response = await axios.post(`${API}v2/broadcaster/removeUserAccess`, {...this.$store.state.broadcasterAuth, viewer_email: email});
      if (response.data.success){
        Swal.fire("Success!", "User removed from team.", "success");
        this.getTeamMembers();
      }else{
        Swal.fire("Error!", "User not removed from team.", "error");
      }
    },

    // addUserToTeam : add a user to the team from the input email, vaildate the email, call the api endpoint /v2/broadcaster/addUserAccess, can then clear the input email
    async addUserToTeam(){
      let email = this.add_email;
      let valid = this.validateEmail(email);
      if (valid){
        let response = await axios.post(`${API}v2/broadcaster/addUserAccess`, {...this.$store.state.broadcasterAuth,viewer_email: email, role: "can_edit"});
        if (response.data.success){
          this.add_email = "";
          await this.getTeamMembers();
          Swal.fire("Success!", "User added to team", "success");
        }
      }else{
        Swal.fire("Invalid Email", "Please enter a valid email.", "error");
      }
    },

  // get the team members from the api endpoint /v2/broadcaster/listUserAccess for the channel
  async getTeamMembers(){
      let getEventResponse = await axios.post(API+ "v2/broadcaster/listUserAccess", {
          ...this.$store.state.broadcasterAuth,
      })
      this.teamMembers = getEventResponse.data.users
  },
  async trialRequest(){
    let response = await axios.post(`${API}v2/broadcaster/request/trial`, {...this.$store.state.broadcasterAuth});
    if (response.data.success){
      Swal.fire("Success!", "Your trial request has been sent. It may take up to 24 hours to be approved.", "success");
    }else{
      Swal.fire("Error!", "Your trial request was declined due to your previous usage of SeasonCast. If you think this is a mistake, please contact Support ", "error");
    }
  },

  async renameChannel(){

    // confirm and understand that this will require re-login on all broadcaster devices. There is no gaurentees that data will be transferred over successfully.
    const didConfirm = await Swal.fire({
      title: "Are you sure?",
      text: "You will need to re-login to broadcaster devices. SeasonCast does not gaurentee that data will be transferred over successfully. We limit re-naming to 3 times a year. Do you want to continue?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, rename it! I understand the risks.",
      closeOnConfirm: false
    })
    if (!didConfirm.isConfirmed){
      return;
    }


    const { value } = await Swal.fire({
      input: 'text',
      inputLabel: 'Enter a new channel username',
      inputPlaceholder: 'Channel Username (Must be unique & not taken)'
    })

    if (value) {
      let response = await axios.post(`${ API}v2/broadcaster/changeUsername`, {...this.$store.state.broadcasterAuth, new_username: value});
      if (response.data.success){
       await Swal.fire("Success!", "Your channel has been renamed. You will need to re-login to broadcaster devices", "success");
        this.logout()

        
      }else{
        Swal.fire("Error!", "Your channel was not renamed.", "error");
      }
    }


  },
  async changeEmail(){

const didConfirm = await Swal.fire({
  title: "Are you sure?",
  text: "You will need to re-login to broadcaster devices. Do you want to continue?",
  type: "warning",
  showCancelButton: true,
  confirmButtonColor: "#DD6B55",
  confirmButtonText: "Yes, rename it! I understand the risks.",
  closeOnConfirm: false
})
if (!didConfirm.isConfirmed){
  return;
}


const { value } = await Swal.fire({
  input: 'text',
  inputLabel: 'Enter a new channel email',
  inputPlaceholder: 'Channel Email'
})

if (value) {
  let response = await axios.post(`${ API}v2/broadcaster/changeEmail`, {...this.$store.state.broadcasterAuth, new_email: value});
  if (response.data.success){
    await Swal.fire("Success!", "Your email has been changed. You will need to re-login to broadcaster devices", "success");
    this.logout()

    
  }else{
    Swal.fire("Error!", "Your email was not changed.", "error");
  }
}


},
  async deleteChannel(){
      const didConfirm = await Swal.fire({
      title: "Are you sure?",
      text: "You will delete your channel. This is not reversable. Please ensure you have downloaded any recordings you want to keep. Please enter your password to confirm.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, I understand.",
      closeOnConfirm: false
    })
    if (!didConfirm.isConfirmed){
      return;
    }
  

    const { value } = await Swal.fire({
      input: 'password',
      inputLabel: 'Enter your password to confirm',
      inputPlaceholder: 'Password for owner of the channel',
   

    })


      let response = await axios.post(`${API}v2/broadcaster/deleteAccount`, {...this.$store.state.broadcasterAuth, password: value});
      if (response.data.success){
        await Swal.fire("Success!", "Your channel has been deleted", "success");
        this.logout()
        
      }else{
        Swal.fire("Error!", "Your channel was not deleted.", "error");
      }
    


  },
 logout: async function () {
     cookie.remove("broadcaster-email", { path: '/' })
     cookie.remove("broadcaster-key", { path: '/' })
         cookie.remove("broadcaster-email")
     cookie.remove("broadcaster-key")
     cookie.remove("broadcaster-token", { path: '/' })
     cookie.remove("viewer-token", { path: '/' })
     cookie.remove("viewer-email", { path: '/' })
         cookie.remove("viewer-token")
     cookie.remove("viewer-email")
     this.$store.commit('setBroadcasterChannels', [])
     this.$router.push('/broadcaster/login');
    
     
     },
  async submitBTN() {
    let getResponse = await axios.post(API+ "v2/broadcaster/premiumWebLink", {
      ...this.$store.state.broadcasterAuth
    }) 
    if (getResponse.data.success){
      window.location = getResponse.data.url
    }
  },
  async did_purchase(){
    await Swal.fire({
  icon: 'success',
  title: 'Success',
  text: 'Thank you for purchasing SeasonCast Premium!',
  footer: 'You may need to refresh SeasonCast for it to take effect'
})

this.$router.push("/broadcaster/settings")
  }
  },
  // You will be redirected to Stripe's secure checkout page

};
</script>
